export default __webpack_public_path__ + "static/media/owner.3eac3467.svg";